import * as React from 'react';
import IconWithText from '../../../../../services/Shared/IconWithText/IconWithText';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { emptyGEPStateContainer } from '../../GoalEditor/GoalEditorPanel/GEPState/emptyGEPStateContainer';
import { GoalEditor } from '../../GoalEditor/GoalEditor';

export const AddNewGoalLink = () => (
	<IconWithText
		iconSuffix={EGlyphicon["plus"]}
		whenClicked={() => GoalEditor(emptyGEPStateContainer)}
		displayAsBlock={true}
	>
		Add Goal
	</IconWithText>
);
